/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  FaInfoCircle,
  FaRegFilePdf,
  FaPaperclip,
  FaRegCopy,
  FaTools,
  FaArrowRight,
  FaArrowLeft,
  FaGlobeAsia,
  FaRegClone,
  FaChalkboardTeacher,
  FaQuestionCircle,
} from 'react-icons/fa';
import { connect } from 'react-redux';

import Translate from './Translate';
import Card from './Card';
import RelatedDocuments from './RelatedDocuments';
import Assistance from './Assistance';
import RelatedSections from './RelatedSections';
import RelatedContent from './RelatedContent';
import Glossary from './Glossary';
import AboutTheDocument from './AboutTheDocument';
// import ExternalLinks from './ExternalLinks';
// import TestMyKnowledge from './TestMyKnowledge';
import ComparisonDocList from '../Comparison/ComparisonDocList';
import { setElementHeights } from '../../assets/constants/strings';
import './style.scoped.scss';
import $ from 'jquery';
import SubscriptionFrame from './SubscriptionFrame';
import Comments from '../Modals/Comments';
import Revealr from './Revealr';
import { BiChip } from 'react-icons/bi';

const RightNav = ({
  handleComparisonDocument,
  handleSetFAQ,
  handleVisibility,
  handleGlossarySelected,
  currentDoc,
  contentType,
  rightNav,
  user,
  accountPage,
  handlePreviousVersion,
  handleSummary,
}) => {
  const [isRightNavVisible, setIsRightNavVisible] = useState(true);
  const [rightNavSass, setRightNavSass] = useState('pt-5');

  useEffect(() => {
    // if we are in small screen mode, hide navigation upon opening
    toggleVisibility(window.innerWidth < 950);

    $(window).on('resize', () => {
      if (window.innerWidth < 950) toggleVisibility(true);
    });
    $('#goog-gt-tt').remove();
    $('.goog-te-spinner-pos').remove();
  }, []);

  useEffect(() => {
    // if it changes to comparison, we want to hide it
    if (window.innerWidth > 950) {
      if (contentType === 'Comparison' || contentType === 'Version')
        toggleVisibility(true);
      else toggleVisibility(false);
    } else toggleVisibility(true);
  }, [contentType]);

  useEffect(() => {
    setRightNavSass('3');
    setIsRightNavVisible(true);

    // if we are in small screen mode, hide navigation upon opening
    toggleVisibility(window.innerWidth < 950);
  }, [currentDoc]);

  const toggleVisibility = (currentBool) => {
    currentBool === true ? setRightNavSass('p-0 ') : setRightNavSass('');

    handleVisibility(!currentBool);
    setIsRightNavVisible(!currentBool);
  };

  const handleSelectedComparisonDocument = (id) => {
    handleComparisonDocument(id);
  };

  useEffect(() => {
    const mainContent = document.getElementById('main-content');
    const footer = document.getElementsByClassName('footer')[0];

    if (mainContent) {
      mainContent.classList.toggle('collapsed-right', !isRightNavVisible);

      if (!isRightNavVisible) {
        // check if footer has been rendered
        if (footer)
          mainContent.style.paddingBottom = `calc(3rem + ${footer.clientHeight}px)`;
      } else {
        // check if footer has been rendered
        if (footer) mainContent.style.paddingBottom = null;
      }
    }
    setElementHeights();
  }, [isRightNavVisible]);

  return (
    <div id='right-nav' className={rightNavSass + 'pr-0 pb-0'}>
      {isRightNavVisible ? (
        <div className='wf-right hide'>
          <FaArrowRight
            title='Collapse Right Navigation'
            className='arrow-container__arrow'
            onClick={() => toggleVisibility(isRightNavVisible)}
          />
        </div>
      ) : (
        <div className='wf-right show'>
          <FaArrowLeft
            title='Expand Right Navigation'
            className='arrow-container__arrow'
            onClick={() => toggleVisibility(isRightNavVisible)}
          />
        </div>
      )}

      {isRightNavVisible && (
        <div
          className='d-flex align-items-end flex-column mh-100 mt-3 pb-3 px-3'
          id='right-nav-items'
        >
          {!accountPage && rightNav && rightNav.length > 0 ? (
            rightNav.map((card, i) => {
              switch (card) {
                case 'RevealrAI': {
                  return (
                    <Card key={i} Icon={<BiChip />} cardTitle='Revealr AI'>
                      <Revealr
                        handleSummary={handleSummary}
                        isSummary={contentType === 'Summary'}
                        currentDoc={currentDoc}
                      />
                    </Card>
                  );
                }
                case 'About': {
                  return (
                    (currentDoc.versionDate ||
                      currentDoc.registrationDate ||
                      currentDoc.previousVersionsList.length > 0) && (
                      <Card
                        key={i}
                        Icon={<FaInfoCircle />}
                        cardTitle='About the Document'
                      >
                        <AboutTheDocument
                          handlePreviousVersion={handlePreviousVersion}
                        />
                      </Card>
                    )
                  );
                }
                case 'Assistance': {
                  return (
                    <Card
                      key={i}
                      Icon={<FaQuestionCircle />}
                      cardTitle='Assistance'
                    >
                      <Assistance handleSetFAQ={handleSetFAQ} />
                    </Card>
                  );
                }
                case 'PDF': {
                  return user && user.restriction > 1 ? (
                    <Card key={i} Icon={<FaRegFilePdf />} cardTitle='Download'>
                      <SubscriptionFrame />
                    </Card>
                  ) : (
                    <Card
                      key={i}
                      Icon={<FaRegFilePdf />}
                      cardTitle='Download'
                      cardItems={[
                        { Text: 'PDF Version' },
                        { Text: 'Word Version' },
                      ]}
                    />
                  );
                }
                case 'Translate': {
                  return (
                    <Card key={i} Icon={<FaGlobeAsia />} cardTitle='Translate'>
                      <Translate />
                    </Card>
                  );
                }
                case 'Related Documents': {
                  return (
                    <Card
                      key={i}
                      Icon={<FaRegCopy />}
                      cardTitle='Related Documents'
                    >
                      {user && user.restriction > 1 ? (
                        <SubscriptionFrame />
                      ) : (
                        <RelatedDocuments />
                      )}
                    </Card>
                  );
                }
                case 'Related Sections': {
                  return (
                    <Card
                      key={i}
                      Icon={<FaChalkboardTeacher />}
                      cardTitle='Related Sections'
                    >
                      {user && user.restriction > 1 ? (
                        <SubscriptionFrame />
                      ) : (
                        <RelatedSections />
                      )}
                    </Card>
                  );
                }
                case 'Document Comparison': {
                  return (
                    <Card
                      key={i}
                      Icon={<FaRegClone />}
                      cardTitle='Document Comparison'
                    >
                      <ComparisonDocList
                        handleSelectedDocument={
                          handleSelectedComparisonDocument
                        }
                      />
                    </Card>
                  );
                }
                case 'Related Content': {
                  return (
                    <Card
                      key={i}
                      Icon={<FaPaperclip />}
                      cardTitle='Related Content'
                    >
                      {user && user.restriction > 1 ? (
                        <SubscriptionFrame />
                      ) : (
                        <RelatedContent />
                      )}
                    </Card>
                  );
                }
                case 'Glossary': {
                  return (
                    <Card key={i} Icon={<FaTools />} cardTitle='Glossaries'>
                      <Glossary
                        handleGlossarySelected={handleGlossarySelected}
                      />
                    </Card>
                  );
                }
                default:
                  return null;
              }
            })
          ) : (
            <React.Fragment>
              <Card Icon={<FaInfoCircle />} cardTitle='Assistance'>
                <Assistance handleSetFAQ={handleSetFAQ} />
              </Card>

              <Card Icon={<FaGlobeAsia />} cardTitle='Translate'>
                <Translate />
              </Card>
            </React.Fragment>
          )}
        </div>
      )}
      <Comments handleDismiss={() => $('#commentsModal').modal('hide')} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentDoc: state.document.currentDocument,
  rightNav: state.client.rightNav,
  user: state.user.user,
});

const connector = connect(mapStateToProps, null);

export default connector(RightNav);
